module.exports = __webpack_public_path__ + "static/media/shadow.be052951.png";